import plus from "../../assets/360/plus.svg";
import minus from "../../assets/360/minus.svg";
import reset from "../../assets/360/reset.svg";
import ZoomImageManager from "./ZoomManager";

interface ZoomBarProps {
  zoomLevel: number;
  zoomManager: ZoomImageManager;
}

const ZoomBar: React.FC<ZoomBarProps> = ({ zoomLevel, zoomManager }) => {
  return (
    <div className="zoom-bar-container">
      <button
        onClick={() => {
          zoomManager.setZoomValue(Number(1));
        }}
        className="reset-button"
      >
        <img src={reset} alt="" />
      </button>

      <section className="zoom-bar">
        <button
          className="btn"
          onClick={() => {
            if (
              zoomLevel >= zoomManager.zoomMinValue &&
              zoomLevel < zoomManager.zoomMaxValue
            ) {
              zoomManager.setZoomValue(
                Number(zoomLevel + zoomManager.zoomRangeStep)
              );
            }
          }}
        >
          <img src={plus} alt="plus"></img>
        </button>
        <div
          onClick={() => {
            if (
              zoomLevel >= zoomManager.zoomMinValue &&
              zoomLevel < zoomManager.zoomMaxValue
            ) {
              zoomManager.setZoomValue(
                Number(zoomLevel + zoomManager.zoomRangeStep)
              );
            }
          }}
          className="overlap-"
        >
          +
        </div>
        <div className="range">
          <div className="line">{}</div>
          <input
            type="range"
            style={{ transform: "rotate(180deg)" }}
            min={zoomManager.zoomMinValue}
            max={zoomManager.zoomMaxValue}
            step={zoomManager.zoomRangeStep}
            onChange={(e) => {
              zoomManager.setZoomValue(Number(e.currentTarget.value));
            }}
            value={zoomLevel}
          ></input>
        </div>
        <div
          onClick={() => {
            if (
              zoomLevel > zoomManager.zoomMinValue &&
              zoomLevel <= zoomManager.zoomMaxValue
            ) {
              zoomManager.setZoomValue(
                Number(zoomLevel - zoomManager.zoomRangeStep)
              );
            }
          }}
          className="overlapP"
        >
          +
        </div>
        <button
          className="btn"
          onClick={() => {
            if (
              zoomLevel > zoomManager.zoomMinValue &&
              zoomLevel <= zoomManager.zoomMaxValue
            ) {
              zoomManager.setZoomValue(
                Number(zoomLevel - zoomManager.zoomRangeStep)
              );
            }
          }}
        >
          <img
            style={{ transform: "rotate(90deg)" }}
            src={minus}
            alt="minus"
          ></img>
        </button>
      </section>
    </div>
  );
};

export default ZoomBar;
